/**
 *  需要原生回调的方法统一管理
 */
import type {
  NativeApiType,
  NativeApiTypeParams,
  NativeToolType,
} from "./type";

const MOCK = false;

const TIME_OUT_SECONDES = 60 * 60 * 1000;

/**
 *
 * @param toolType :原生中定义的方法名字 like -> StarCharge_tools……
 * @param params : 需要传入的参数
 * @returns
 */
export const flutterHandle = (toolType: NativeToolType, params: unknown) => {
  return window?.flutter_inappwebview?.callHandler(toolType, params);
};

/**
 *
 * @param type 调用的地方传入的需要flutter做什么功能的定义，具体方法具体维护
 * @param params 调用flutter方法的参数信息
 * @param toolType 原生中定义的方法名字 like -> StarCharge_tools……
 * @param timeout 调用flutter方法的延迟清空function时间
 */
export const callNativeApiWithCallBack = <T extends NativeApiType>(
  type: NativeApiType,
  params: NativeApiTypeParams<T>,
  toolType: NativeToolType = "StarCharge_tools", // 默认星充方法
  timeout: number = TIME_OUT_SECONDES,
) => {
  return new Promise((resolve) => {
    const now = new Date().getTime();
    const callbackFunctionName: string = `${type}${now}`;
    window[callbackFunctionName] = (p) => {
      resolve(p);
      window[callbackFunctionName] = undefined;
    };
    const map = {
      type: type,
      functionName: callbackFunctionName,
      ...params,
    };
    const stringParams = JSON.stringify(map);
    if (MOCK) {
      // 如果是mock方法，则执行，还未定义。
    } else {
      flutterHandle(toolType, stringParams);
    }
    setTimeout(() => {
      window[callbackFunctionName] = undefined;
    }, timeout);
  });
};

// 不需要callBack,比如拨打电话，跳转设备详情页等方法
export const callNativeApi = <T extends NativeApiType>(
  type: NativeApiType,
  params: NativeApiTypeParams<T>,
  toolType: string = "StarCharge_tools", // 默认星充方法
) => {
  const map = {
    type: type,
    functionName: "",
    ...params,
  };
  console.log("map", map);
  const stringParams = JSON.stringify(map);

  flutterHandle(toolType, stringParams);
};
